import React, { useState, useEffect } from 'react';
import './style.css';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { ReactComponent as EDITLOGO } from '../../../../assets/images/editgroup.svg';
import { ReactComponent as BACKBUTTON } from '../../../../assets/images/backbutton.svg';
import Input from '../../../common/InputField';
import EditGroupTable from './EditGroupTable';
import { updateGroupApi } from '../../../../store/features/updateCoUser';
import { ListGroupIndiApi } from '../../../../store/features/ListGroupIndividual';
import { DeleteCoUserFromGroupApi } from '../../../../store/features/deleteCoUserFromGroup';
import { selectSelectedState } from '../../../../Redux/teamSlice';
import AddCoUser from './AddCoUser';
import SearchGroupField from './searchGroup';
import DeletePopUp from '../../../dashboardcomponents/DeletePopUp';
import { deleteGroupApi } from '../../../../store/features/deleteGroup';
import { Avatar, Button } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';

function EditGroupMain() {
  const [image, setImage] = useState(null);
  const [editLogoSrc, setEditLogoSrc] = useState(null);
  const [groupName, setGroupName] = useState('');
  const [agentGroupName, setAgentGroupName] = useState('');
  const [listOfUsers, setListOfUsers] = useState([]);
  const [groupInvites, setGroupInvites] = useState('');
  const [groupData, setGroupData] = useState([]);
  const [groupUserId, setGroupUserId] = useState('');
  const [groupMainId, setGroupMainId] = useState('');
  const [loading, SetLoading] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [deleteUser, setDeleteUser] = useState(false);
  const [error, setError] = useState('');
  const [isUploading, setIsUploading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { groupId } = useParams();
  const selectedState = useSelector(selectSelectedState);
  const chracterPosition = (alphabet) => {
    const alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const positionOfAlphabet = alphabets.indexOf(alphabet) + 1;
    return positionOfAlphabet;
  };
  const colorCodesForAvatar = [
    "#405261", // A
    "#FF4D4F", // B
    "#FA541C", // C
    "#FA8C16", // D
    "#FAAD14", // E
    "#EB2F96", // F
    "#FADB14", // G
    "#A0D911", // H
    "#52C41A", // I
    "#5CDBD3", // J
    "#9254DE", // K
    "#F759AB", // L
    "#2F54EB", // M
    "#722ED1", // N
    "#1890FF", // O
    "#13C2C2", // P
    "#2DB7F5", // Q
    "#19BE6B", // R
    "#30A745", // S
    "#FA8C16", // T
    "#FAAD14", // U
    "#9254DE", // V
    "#F759AB", // W
    "#13C2C2", // X
    "#722ED1", // Y
    "#2DB7F5", // Z
  ];
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
    setEditLogoSrc(URL.createObjectURL(file));
  };

  const handleUploadClick = () => {
    document.getElementById('imageInput').click();
  };
  const handleGoBack = () => {
    navigate(-1);
  };
  const currentLanguage = useSelector(
    (state) => state.language.currentLanguage,
  );
  const t = useSelector(
    (state) => state.language.translations[currentLanguage],
  );
  const updateGroupHandler = async () => {
    if (groupName.trim().length < 3) {
      setError('Group name must be at least 3 characters.');
      return;
    }
    if (groupName.trim().length > 50) {
      setError('Group name cannot be more than 50 characters.');
      return;
    }

    const formData = new FormData();
    formData.append('title', groupName);
    listOfUsers.forEach((email) => {
      formData.append('invites[]', email);
    });
    if (image) {
      formData.append('group_image', image); // Append the actual image file
    }
    setIsUploading(true)
    const updategroup = dispatch(
      updateGroupApi({
        id: groupId,
        formData,
      }),
    );
    updategroup
      .then(async (data) => {
        if (typeof data.payload === 'undefined') {
          toast.error('Some Error Occured. Please try again later.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        } else if (data?.payload?.status === 400) {
          toast.error(data.payload.message, {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        } else if (data.payload.status === 200) {
          toast.success('Group Updated successfully.');
          navigate(-1);
          setIsUploading(false)
        } else if (data?.payload?.status === 500) {
          toast.error('Some Error Occured. Please try again later.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        }
      })
      .catch(async (error) => {
        toast.error(error, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        });
      });
  };

  const getGroupIndividaul = async () => {
    setIsLoading(true);
    try {
      const listCoUserList = dispatch(
        ListGroupIndiApi({
          id: groupId,
        }),
      );

      const data = await listCoUserList;

      if (data?.payload?.status === 200) {

        const item = data?.payload?.data;
        setGroupData((prevGroups) => {
          const newGroupData = [];
          setAgentGroupName(item?.group.title)
          // data?.payload?.data?.forEach((item) => {
          setGroupName(item?.group.title);
          setEditLogoSrc(item?.group?.group_image);
          setGroupMainId(item?.group?._id);
          item.users.forEach((group) => {
            setGroupUserId(group?.id);
            newGroupData.push(group);
          });
          // });
          return newGroupData;
        });
      }
    } catch (error) {
      // Handle errors
    } finally {
      setIsLoading(false);
    }
  };
  const deleteUserHandler = async () => {
    try {
      const deleteuserList = await dispatch(
        DeleteCoUserFromGroupApi({
          requestHeaders: {
            agent_id: groupUserId,
            group_id: groupMainId,
          },
        }),
      );
      if (deleteuserList?.payload?.status === 200) {
        toast.success(deleteuserList.payload.message);
        await getGroupIndividaul();
        setRefreshTrigger(prev => prev + 1);
      }
      else if (deleteuserList?.payload?.status === 500) {
        toast.error('Some Error Occured. Please try again later.');
      }
    } catch (error) {
      console.error(error);
      toast.error('An error occurred. Please try again later.');
    }
  };
  useEffect(() => {
    getGroupIndividaul();
  }, []);

  const handleGroupNameChange = (e) => {
    const value = e.target.value;
    setGroupName(value);

  };

  const deleteGroupHandler = async () => {
    try {
      const deletegroupdispatcher = dispatch(
        deleteGroupApi({
          id: groupId
        }),
      );
      const data = await deletegroupdispatcher;
      if (!data.payload) {
        toast.error('Some Error Occurred. Please try again later.');
        SetLoading(false);
      } else if (data.payload.status === 200) {
        toast.success(data?.payload?.message);
        getGroupIndividaul();
        navigate(-1)
      } else if (data.payload.status === 404) {
        toast.error('No Record Found');
      } else if (data.payload.status === 500) {
        toast.error('Internal Server Error. Please try again later.');
        SetLoading(false);
      } else {
        toast.error(`Unexpected response: ${JSON.stringify(data.payload)}`);
        SetLoading(false);
      }
    } catch (error) {
      toast.error('An error occurred. Please try again later.');
      SetLoading(false);
    }
  };

  const renderSkeleton = () => (
    <div className="EditGroup-Main-Container">
      <div className="EditGroup-Logo-Container">
        <div className="EDITGROUP-LOGO-MAIN">
          <Skeleton variant="circular" width={56} height={56} />
          <div>
            <Skeleton variant="text" width={120} height={20} />
            <Skeleton variant="text" width={80} height={16} />
          </div>
        </div>
        <div className="Edit-Group-Main-Button">
          <Skeleton variant="rounded" width={80} height={32} />
          <Skeleton variant="rounded" width={100} height={32} />
        </div>
      </div>
      <div className="EditGroup-Input-Container">
        <Skeleton variant="rectangular" width="100%" height={56} />
        <div className="AddMember-Container">
          <Skeleton variant="rectangular" width="100%" height={56} />
          <Skeleton variant="rectangular" width={200} height={56} />
        </div>
      </div>
      <div className="EditGroup-Table-Container">
        <Skeleton variant="rectangular" width="100%" height={200} />
      </div>
      <Skeleton variant="rounded" width={120} height={40} sx={{ marginTop: '20px' }} />
    </div>
  );

  return (
    <>
      <div style={{
        paddingLeft: '24px',
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0,
        marginTop: '19px'
      }} className="EditBack-profile" onClick={handleGoBack}>
        <BACKBUTTON />

        <p className="Edit-Back-Button">{t.EDITGROUP}</p>
      </div>
      {isLoading ? (
        renderSkeleton()
      ) : (
        <>
          <div className="EditGroup-Main-Container">
            <div className="EditGroup-Logo-Container">
              <div className="EDITGROUP-LOGO-MAIN">
                {editLogoSrc ? (
                  <Avatar src={editLogoSrc} alt="Group Logo" style={{ width: '56px', height: '56px', borderRadius: '32px' }} />
                ) : (
                  <p>
                    <Avatar
                      src={EDITLOGO}


                      sx={{
                        width: 56,
                        height: 56,
                        bgcolor:
                          colorCodesForAvatar[
                          chracterPosition(
                            agentGroupName
                              .substring(0, 1)
                              .toUpperCase()
                          )
                          ],
                      }}
                    >
                      {agentGroupName
                        .substring(0, 1)
                        .toUpperCase()}
                    </Avatar>
                  </p>
                )}
                <input
                  type="file"
                  accept=".jpg, .jpeg, .png"
                  onChange={handleImageChange}
                  style={{ display: 'none' }}
                  id="imageInput"
                />
                <div>
                  <p className="Edit-profileText">{groupName}</p>
                  <p className="EditAgent-profile">
                    {groupData.length} members
                  </p>
                </div>
                {/* <label htmlFor="imageInput">
                  <p className="ChangeP01">{t.CHANGEPICTURE}</p>
                </label> */}
              </div>
              <div className="Edit-Group-Main-Button">
                <button className="EditGroup-Active" type="button" onClick={handleUploadClick}>
                  {t.UPLOAD}
                </button>
                <button disabled={isUploading} className="EditGroup-Delete" type="button" onClick={updateGroupHandler}>
                  Update
                </button>
              </div>
            </div>
            <div className="EditGroup-Input-Container">
              <Input
                title={t.GROUPNAME}
                placeholder={t.ENTERGROUPNAME}
                value={groupName}
                sx={{
                  '& input::placeholder': {
                    color: '#C5CED6',
                    opacity: 1,
                    fontSize: '14px',
                    fontWeight: 400,
                  },
                }}
                onChange={handleGroupNameChange}
              />
              {error && (
                <span style={{ color: "red", fontSize: "12px", marginTop: "8px" }}>
                  {error}
                </span>
              )}
              <div className="AddMember-Container">
                <AddCoUser
                  title={t.ADDMEMEBER}
                  placeholder={t.ENTERADDMEMBER}
                  onChange={(e) => setGroupInvites(e.target.value)}
                  setListOfUsers={setListOfUsers}
                  refreshTrigger={refreshTrigger}  // Add this prop
                />
                <SearchGroupField className="searchGroupInput" title="Search" placeholder="Search" />
              </div>
            </div>
            {groupData.length > 0 && <div className="EditGroup-Table-Container">
              <EditGroupTable groupData={groupData} deleteUserHandler={deleteUserHandler} />
            </div>}

            <Button

              className="DeleteGroupButton"
              onClick={() => setDeleteUser(true)}


            >
              Delete Group
            </Button>
            {deleteUser && (
              <DeletePopUp
                onCancel={() => setDeleteUser(false)}
                onDelete={() => { deleteGroupHandler(); setDeleteUser(false); }}
              />
            )}


          </div>
        </>
      )}
    </>
  );
}

export default EditGroupMain;